"use client";
//#region packages/@mantine/core/src/components/Group/Group.module.css
var Group_module_default = { "root": "m_4081bf90" };
//#endregion
export { Group_module_default as default };

//# sourceMappingURL=Group.module.mjs.map